import { useState } from 'react';
import { Avatar, Badge, Empty } from 'antd';
import { MessageOutlined, RobotOutlined, BellOutlined, NotificationOutlined } from '@ant-design/icons';

const mockMessages = [
  { id: 1, type: 'system', title: '欢迎使用西蒙的猫', content: '与AI协作，释放你的创作潜能。完成首次对话即可获得额外积分奖励！', time: '2天前', read: false },
  { id: 2, type: 'community', title: '你的作品被精选了！', content: '你发布的「Simon\'s Cat 品牌升级方案」已被选为广场精选作品', time: '3天前', read: true },
  { id: 3, type: 'credit', title: '积分到账提醒', content: '每日登录积分 +10 已到账，当前总积分 59', time: '5天前', read: true },
  { id: 4, type: 'system', title: '新版本更新 v2.0', content: '新增图片生成4图模式、项目知识库社区评论功能', time: '1周前', read: true },
];

const MessagesPage = () => {
  const [filter, setFilter] = useState('all');
  const unreadCount = mockMessages.filter((m) => !m.read).length;

  const filtered = filter === 'all'
    ? mockMessages
    : mockMessages.filter((m) => m.type === filter);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: '#fff' }}>消息中心</h1>
        {unreadCount > 0 && (
          <button
            style={{
              padding: '6px 14px', borderRadius: 8,
              background: 'rgba(180,210,160,0.08)',
              border: '1px solid rgba(180,210,160,0.15)',
              color: '#B4D2A0', fontSize: 13, cursor: 'pointer',
            }}
          >
            全部标记已读 ({unreadCount})
          </button>
        )}
      </div>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {[
          { key: 'all', label: '全部' },
          { key: 'system', label: '系统' },
          { key: 'community', label: '社区' },
          { key: 'credit', label: '积分' },
        ].map((tab) => (
          <button
            key={tab.key}
            onClick={() => setFilter(tab.key)}
            style={{
              padding: '6px 14px', borderRadius: 20,
              background: filter === tab.key ? 'rgba(180,210,160,0.08)' : 'rgba(255,255,255,0.03)',
              border: filter === tab.key ? '1px solid rgba(180,210,160,0.2)' : '1px solid rgba(255,255,255,0.06)',
              color: filter === tab.key ? '#B4D2A0' : 'var(--text-tertiary)',
              fontSize: 13, cursor: 'pointer',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Message list */}
      {filtered.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {filtered.map((msg) => (
            <div
              key={msg.id}
              className="glass-card"
              style={{
                padding: '20px',
                cursor: 'pointer',
                borderLeft: msg.read ? '2px solid transparent' : '2px solid var(--brand-primary)',
                transition: 'all 200ms',
              }}
            >
              <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: msg.type === 'system' ? 'rgba(245,200,64,0.08)' : msg.type === 'credit' ? 'rgba(245,200,64,0.08)' : 'rgba(79,232,182,0.06)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: msg.type === 'credit' ? '#F5C840' : '#4FA8FF', flexShrink: 0,
                }}>
                  {msg.type === 'system' && <BellOutlined />}
                  {msg.type === 'community' && <RobotOutlined />}
                  {msg.type === 'credit' && <NotificationOutlined />}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <span style={{ fontSize: 14, fontWeight: msg.read ? 400 : 600, color: '#fff' }}>{msg.title}</span>
                    <span style={{ fontSize: 12, color: 'var(--text-tertiary)', flexShrink: 0 }}>{msg.time}</span>
                  </div>
                  <p style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5, margin: 0 }}>
                    {msg.content}
                  </p>
                </div>
                {!msg.read && (
                  <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--brand-primary)', marginTop: 6, flexShrink: 0 }} />
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Empty description={<span style={{ color: 'var(--text-tertiary)' }}>暂无消息</span>} style={{ padding: '80px 0' }} />
      )}
    </div>
  );
};

export default MessagesPage;
